const APP_NAME = 'Manta Web App';
export default APP_NAME;
